import { Controller } from "@hotwired/stimulus"
import QRCodeStyling from "qr-code-styling"

// Connects to data-controller="qr-code"
export default class extends Controller {
  static targets = ["container", "printable"]

  static values = {
    data: String,
    imagePath: String,
    autoPrint: Boolean,
  }

  connect() {
    this.qrCode = new QRCodeStyling({
      width: 190,
      height: 190,
      data: this.dataValue,
      type: "svg",
      image: this.imagePathValue,
      cornersSquareOptions: {
        color: "rgb(147, 197, 114)",
        type: "extra-rounded",
      },
      cornersDotOptions: {
        color: "rgb(95, 142, 74)",
        type: "extra-rounded",
      },
    })

    this.qrCode.append(this.containerTarget)

    if (this.autoPrintValue) {
      setTimeout(() => {
        window.print()
      }, 100)
    }
  }
}
